import type { WorkCondition, WorkFormat } from "@/types/work.types";

export const formatWorkPrice = (value: number | null): string =>
  value == null
    ? "Unavailable"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);

export const formatWorkPriceRange = (format: WorkFormat): string => {
  if (format.lowestPrice == null || format.lowestPrice <= 0) {
    return "Out of stock";
  }
  if (
    format.highestPrice == null ||
    format.lowestPrice === format.highestPrice
  ) {
    return formatWorkPrice(format.lowestPrice);
  }

  return `${formatWorkPrice(format.lowestPrice)} - ${formatWorkPrice(format.highestPrice)}`;
};

export const getConditionDescription = (
  condition: WorkCondition,
): string | null => {
  const descriptions: Record<string, string> = {
    New: "A brand-new, unused copy in perfect condition.",
    "Like New": "An apparently unread copy in perfect condition.",
    "Very Good": "A read copy, but remains in excellent condition.",
    Good: "A read copy that remains in clean condition.",
    Acceptable: "A readable copy with all pages intact.",
  };

  return descriptions[condition.name] ?? null;
};
